import React from 'react'
import { Button, Col, Form, Input, Row } from 'antd'
import { ButtonEx } from '../../../../../../styles/button.style'
import _ from 'lodash'
import { useDeepEffect } from '../../../../../../utils/hooks'

const UpdateBranch = ({ form, onOk, onCancel, heroId, branch }) => {
  const { setFieldsValue, getFieldDecorator, validateFields } = form

  useDeepEffect(() => {
    if (!_.isEmpty(branch)) {
      setFieldsValue({
        branch: branch
      })
    }
  }, [branch])

  function onSubmit(e) {
    e.preventDefault()
    validateFields((err, values) => {
      if (!err) {
        const data = {
          heroId: heroId,
          branchAvailable: values.branch
        }
        onOk(data)
      }
    })
  }

  return (
    <Form onSubmit={onSubmit} layout="vertical">
      <Form.Item label="Branch">
        {getFieldDecorator(`branch`, {
          initialValue: branch,
          rules: [
            {
              required: true,
              message: 'กรุณาเลือก'
            }
          ]
        })(<Input type="number" min="1" />)}
      </Form.Item>
      <Row type="flex" gutter={8} justify="end">
        <Col>
          <Button onClick={() => onCancel()}>ยกเลิก</Button>
        </Col>
        <Col>
          <ButtonEx color="#6ebf4b" type="primary" htmlType="submit">
            บันทึก
          </ButtonEx>
        </Col>
      </Row>
    </Form>
  )
}

const WrappedUpdateBranch = Form.create({ name: 'UpdateBranch' })(UpdateBranch)
export default WrappedUpdateBranch
